import axios from "axios"
import { actions as loadingActions } from "../store/slices/loadingSlice.js"
import { actions as globalErrorActions } from "../store/slices/globalErrorSlice.js"
import { actions as loginActions } from "../store/slices/loginSlice.js"
import lsActions from "./ls.js"

const environmentType = process.env.REACT_APP_ENV
console.log("ENV type: " + environmentType)

let apsoluteDomain
let baseURL
if (environmentType === "development") {
  // apsoluteDomain = "";
  // baseURL = "odisej";
  apsoluteDomain = "https://backend-loyalty-test.ipc.hr"
  baseURL = "odisej_dev"
} else if (environmentType === "production") {
  apsoluteDomain = "https://backend.inaepclub.ba"
  baseURL = "odisej"
} else if (environmentType === "test") {
  apsoluteDomain = "https://backend-loyalty-test.ipc.hr"
  baseURL = "odisej_dev"
}

export const getApsoluteDomain = () => {
  return `${apsoluteDomain}/${baseURL}`
}

const schemaName = "LOYALTY_REST"

export let id = 0

export const raiseId = () => {
  id++
  return id
}

const checkIfFieldEmpty = (pField, pMsg, pThunkApi) => {
  if (pField === "" || pField === null || pField === undefined) {
    return pThunkApi.rejectWithValue({
      message: pMsg,
      isErrorOnServer: false,
    })
  }

  return null
}

/////////////////////////////////////////////////////////////////////////////////LOGIN
const asyncLogin = async ({ data, thunkAPI }) => {
  const innerId = raiseId() //dizemo globalni id konekcije za 1

  const isUserIdentifierEmpty = checkIfFieldEmpty(
    data.P_USER_IDENTIFIER,
    "userNameShouldNotBeEmpty",
    thunkAPI
  )
  if (isUserIdentifierEmpty) {
    return isUserIdentifierEmpty
  }
  //provjeravamo ako je user identifier empty, ako ne, rejectamo thunk

  //provjeravamo ako je pass empty, ako ne, rejectamo thunk

  thunkAPI.dispatch(
    loadingActions.addToLoadingBucket({
      id: innerId,
      path: "login",
      aborted: thunkAPI.signal?.aborted,
    })
  )
  //palimo loading

  let response
  try {
    response = await axios({
      method: "post",
      url: `${apsoluteDomain}/${baseURL}/${schemaName}/customers/login_customer`,
      data: JSON.stringify({
        ...data,
        P_LANG: thunkAPI.getState().systemState.lang,
      }),
      headers: {
        "Content-Type": "application/json",
        P_LANG: thunkAPI.getState().systemState.lang,
      },
    })
    //pokusavamo dobiti odgovor do baze
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
    //gasimo ako smo uspje�ni
  } catch (err) {
    console.log("connectError", err)
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
    thunkAPI.dispatch(globalErrorActions.raiseGlobalError({ msg: err.message }))
    return thunkAPI.rejectWithValue({
      message: err.message,
      status: err.response.status,
      isErrorOnServer: true,
    })
  }

  const result = JSON.parse(response.data.P_RESULT)

  if (!result.isSuccess) {
    return thunkAPI.rejectWithValue({
      message: result.error,
      isErrorOnServer: true,
    })
  }
  return response.data
}

/////////////////////////////////////////////////////////////////////////////////RELOGIN

const relogin = async ({ localStorageIdentifier, thunkAPI, data }) => {
  const userInfoFromLs = lsActions.getFromLs({ key: localStorageIdentifier }) //procitaj iz local storage
  const userInfo = JSON.parse(userInfoFromLs) //parsiraj procitano

  if (!userInfoFromLs) {
    return thunkAPI.rejectWithValue({
      message: "No local storage",
    })
  }

  const innerId = raiseId()

  thunkAPI.dispatch(
    loadingActions.addToLoadingBucket({
      id: innerId,
      path: "relogin",
      aborted: thunkAPI.signal?.aborted,
    })
  )

  let response
  try {
    response = await axios({
      method: "post",
      url: `${apsoluteDomain}/${baseURL}/${schemaName}/customers_protected/relogin_customer`,
      data: JSON.stringify({
        P_ID: userInfo.id,
        P_CLIENT_ID: userInfo.ci,
        P_AUTH_METHOD: userInfo.loginMethod,
        P_LANG: thunkAPI.getState().systemState.lang,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
        P_LANG: thunkAPI.getState().systemState.lang,
      },
    })
  } catch (err) {
    console.log("connectError", err)
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))

    if (err.response?.status !== 401) {
      thunkAPI.dispatch(
        globalErrorActions.raiseGlobalError({ msg: err.message })
      )
    }

    return thunkAPI.rejectWithValue({
      message: err.message,
      status: err.response.status,
    })
  } finally {
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
  }

  const responseDataStringigied = response.data.P_RESULT
  const responseData = JSON.parse(responseDataStringigied)

  if (!responseData.isSuccess) {
    return thunkAPI.rejectWithValue({
      message: "reloginFailed",
    })
  }

  return response.data
}

/////////////////////////////////////////////////////////////////////////////////REGISTER

const asyncRegister = async ({ data, thunkAPI }) => {
  const innerId = raiseId()
  thunkAPI.dispatch(
    loadingActions.addToLoadingBucket({
      id: innerId,
      path: "register",
      aborted: thunkAPI.signal?.aborted,
    })
  )

  let response
  try {
    response = await axios({
      method: "post",
      url: `${apsoluteDomain}/${baseURL}/${schemaName}/customers/register_new_customer`,
      data: JSON.stringify({
        ...data,
        P_LANG: thunkAPI.getState().systemState.lang,
      }),
      headers: {
        "Content-Type": "application/json",
        P_LANG: thunkAPI.getState().systemState.lang,
      },
    })
  } catch (err) {
    console.log("connectError", err)
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
    thunkAPI.dispatch(globalErrorActions.raiseGlobalError({ msg: err.message }))
    return thunkAPI.rejectWithValue({
      message: err.message,
    })
  } finally {
    thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
  }

  const responseDataStringigied = response.data.P_RESULT
  const responseData = JSON.parse(responseDataStringigied)

  if (!responseData.isSuccess) {
    return thunkAPI.rejectWithValue({
      message: responseData.error,
    })
  }

  return response.data
}

//////////////////////////////////////////////////////////////////////////////////////////////UNIVERSAL CONNECTION

const universialConnection = async ({
  method,
  path,
  data,
  headers,
  thunkAPI,
  turnOnLoading = true,
}) => {
  const innerId = raiseId()
  const token = thunkAPI.getState().loginState?.login?.token?.token

  //turn on loading

  let response

  if (thunkAPI.signal?.aborted) {
    return thunkAPI.rejectWithValue({
      message: "aborted",
    })
  }
  if (turnOnLoading) {
    thunkAPI.dispatch(
      loadingActions.addToLoadingBucket({
        id: innerId,
        path: path,
        aborted: thunkAPI.signal?.aborted,
      })
    )
  }

  //console.log("hihi", token)

  try {
    response = await axios({
      method: method,
      url: `${apsoluteDomain}/${baseURL}/${schemaName}/${path}`,
      data: JSON.stringify({
        ...data,
        P_LANG: thunkAPI.getState().systemState.lang,
      }),
      headers: {
        P_CUSTOMERS_ID: thunkAPI.getState().loginState?.login?.userInfo?.id,
        P_HASHED_EMAIL: thunkAPI.getState().loginState?.login?.userInfo?.hEmail,
        P_LOGIN_METHOD: thunkAPI.getState().loginState?.login?.loginMethod,
        P_LANG: thunkAPI.getState().systemState.lang,
        ...headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
  } catch (err) {
    console.log("connectError", err)
    if (turnOnLoading) {
      thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
    }
    const status = err.response?.status

    if (status != 401) {
      thunkAPI.dispatch(
        globalErrorActions.raiseGlobalError({ msg: err.message })
      )
    } else {
      thunkAPI.dispatch(loginActions.expireToken())
    }

    return thunkAPI.rejectWithValue({
      message: err.message,
      status: status,
    })
  } finally {
    if (turnOnLoading) {
      thunkAPI.dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }))
    }
  }

  if (thunkAPI.signal?.aborted) {
    return thunkAPI.rejectWithValue({
      message: "aborted",
    })
  }

  return response.data
}

const getImageSource = (imageCode) => {
  return `${apsoluteDomain}/${baseURL}/${schemaName}/images/get_code/${imageCode}`
}

const myGet = (paramOBJ) => universialConnection({ ...paramOBJ, method: "get" })
const myPost = (paramOBJ) =>
  universialConnection({ ...paramOBJ, method: "post" })
const myPut = (paramOBJ) => universialConnection({ ...paramOBJ, method: "put" })
const myDelete = (paramOBJ) =>
  universialConnection({ ...paramOBJ, method: "delete" })

const myConnections = {
  get: myGet,
  post: myPost,
  put: myPut,
  delete: myDelete,
  login: asyncLogin,
  register: asyncRegister,
  relogin: relogin,
  getImageSourceFromDb: getImageSource,
}

export default myConnections
